<app-user-log
    [users]="users$ | async"
    [loading]="loading$ | async"
    [error]="error$ | async">
</app-user-log>
